const firebaseConfig = {
  apiKey: "AIzaSyBcwnbaurLu-iqnCZDLd09m9pw5hDG0LCw",
  authDomain: "crypto-cite.firebaseapp.com",
  projectId: "crypto-cite",
  storageBucket: "crypto-cite.appspot.com",
  messagingSenderId: "422038161412",
  appId: "1:422038161412:web:d4b35b12709fca96ca8d51",
};

export default firebaseConfig;
